import type { TimelineType } from "@/types/content";

interface TimelineMeta {
  label: string;
  chip: string;
  dot: string;
  rail: string;
}

export const timelineMeta: Record<TimelineType, TimelineMeta> = {
  start: {
    label: "首发爆料",
    chip: "bg-primary-100 text-primary-800 border-primary-200",
    dot: "bg-primary-500",
    rail: "bg-primary-300",
  },
  update: {
    label: "官方更新",
    chip: "bg-secondary-100 text-secondary-800 border-secondary-200",
    dot: "bg-secondary-500",
    rail: "bg-secondary-300",
  },
  reversal: {
    label: "关键反转",
    chip: "bg-accent-100 text-accent-900 border-accent-300",
    dot: "bg-accent-500",
    rail: "bg-accent-400",
  },
  followup: {
    label: "后续追踪",
    chip: "bg-background-200 text-foreground-700 border-background-300",
    dot: "bg-foreground-400",
    rail: "bg-background-400",
  },
};

export const formatHeat = (value: number) => {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return String(value);
};

export const relativeFromIndex = (index: number) => `${index + 1} 天前`;